module.exports = __webpack_public_path__ + "static/media/US.7eaddd32.png";